// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__pFnyr","col":"styles_col__3ryjD"};